'use client';
import 'client-only';

import { ToolsTalentsInviteFeature } from '../common/features/tools-talents-invite-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsTalentsInviteFeature = createUseFlag(
  ToolsTalentsInviteFeature
);
